<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        md="6"
        offset="3"
      >
        <v-card
          class="card"
          color="primary"
        >
          <v-card-title class="font-weight-bold justify-center">
            Evaluación antecedentes
          </v-card-title>
          <v-card-text>
            <v-container class="mb-4">
              <v-row align="center">
                <v-col
                  cols="4"
                  align="center"
                >
                  <v-progress-circular
                    :value="activeStep * 33.3"
                    v-bind="circularProgressProps"
                  />
                </v-col>
                <v-col cols="8">
                  <div class="text-caption text--primary">
                    PASO {{ activeStep }}
                  </div>
                  <div class="text-subtitle-1 font-weight-bold text--primary">
                    {{ activeStepTitle }}
                  </div>
                  <a
                    v-show="activeStep !== 1"
                    class="text-decoration-none secondary--text"
                    @click="activeStep--"
                    @keydown="activeStep--"
                  >Volver al paso anterior</a>
                </v-col>
              </v-row>
            </v-container>
            <v-container v-if="activeStep === 1">
              <v-row>
                <v-col cols="12">
                  <v-date-picker
                    v-model="antecedentes.fechaEvaluacion"
                    locale="es"
                    color="secondary"
                    no-title
                    full-width
                  />
                </v-col>
              </v-row>
            </v-container>
            <v-container v-else-if="activeStep === 2">
              <v-row>
                <v-col cols="12">
                  <v-date-picker
                    v-model="antecedentes.fechaOficio"
                    locale="es"
                    color="secondary"
                    no-title
                    full-width
                  />
                  <v-text-field
                    v-model="antecedentes.oficioAntecedentes"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    label="Número de oficio"
                  />
                </v-col>
              </v-row>
            </v-container>
            <v-container v-else-if="activeStep === 3">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="antecedentes.matriculaCartilla"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    label="Matrícula de cartilla SMN"
                  />
                  <v-textarea
                    v-model="antecedentes.resultado"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    label="Resultado"
                    no-resize
                    rows="3"
                  />
                  <v-textarea
                    v-model="antecedentes.observaciones"
                    rounded
                    filled
                    dense
                    background-color="primary"
                    color="secondary"
                    label="Observaciones"
                    no-resize
                    rows="3"
                  />
                  <v-file-input
                    v-model="file"
                    label="Adjunto antecedentes"
                    rounded
                    filled
                    background-color="primary"
                    color="secondary"
                    dense
                    prepend-icon="mdi-file"
                  />
                </v-col>
              </v-row>
            </v-container>
            <v-container>
              <v-row>
                <v-col
                  md="12"
                  align="center"
                >
                  <v-btn
                    rounded
                    class="mx-8"
                    elevation="8"
                    color="secondary"
                    :loading="loading"
                    :disabled="!validActiveStep || loading"
                    @click="activeStepButtonHandler"
                  >
                    {{ activeStepButtonLabel }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import { circularProgressProps } from '../../components/props/props';

export default {
  props: {
    idDerivacion: {
      type: Number,
      required: true,
    },
    idProgramacion: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      circularProgressProps,

      loading: false,
      areaInteresForm: false,
      sintesisForm: false,
      lineamientosForm: false,
      diagnosticoForm: false,

      activeStep: 1,

      antecedentes: {
        fk_idDerivacion: this.idDerivacion,
        fk_idProgramacion: this.idProgramacion,
        fechaElaboracion: moment().format('DD/MM/YYYY'),
        fechaEvaluacion: null,
        oficioAntecedentes: '',
        fechaOficio: null,
        matriculaCartilla: '',
        resultado: '',
        observaciones: '',
        adjunto: '',
      },

      file: null,

      nameRules: [(v) => !!v || 'Este campo es requerido.'],
    };
  },

  computed: {
    activeStepTitle() {
      switch (this.activeStep) {
        case 1:
          return 'Fecha de evaluación';
        case 2:
          return 'Oficio';
        case 3:
          return 'Resultado';
        default:
          return '';
      }
    },

    validActiveStep() {
      switch (this.activeStep) {
        case 1:
          return true;
        case 2:
          return true;
        case 3:
          return true;
        default:
          return false;
      }
    },

    activeStepButtonLabel() {
      if (this.activeStep < 3) {
        return 'Siguiente paso';
      }
      return 'Registrar evaluación';
    },
  },

  methods: {
    ...mapActions('evaluacionesAntecedentes', ['saveEvaluacionAntecedentes']),
    ...mapActions('derivaciones', ['updateDerivacion', 'updateEstatusDerivacion', 'fetchDerivacionesByArea']),

    async activeStepButtonHandler() {
      if (this.activeStep < 3) {
        this.activeStep += 1;
      } else {
        this.loading = true;

        await this.saveEvaluacionAntecedentes({
          fk_idDerivacion: this.idDerivacion,
          fk_idProgramacion: this.idProgramacion,
          fechaElaboracion: moment().format('DD/MM/YYYY'),
          fechaEvaluacion: moment(this.antecedentes.fechaEvaluacion).format('DD/MM/YYYY'),
          oficioAntecedentes: this.antecedentes.oficioAntecedentes,
          fechaOficio: moment(this.antecedentes.fechaOficio).format('DD/MM/YYYY'),
          matriculaCartilla: this.antecedentes.matriculaCartilla,
          resultado: this.antecedentes.resultado,
          observaciones: this.antecedentes.observaciones,
          adjunto: this.file.name,
          file: this.file,
        });

        await this.updateEstatusDerivacion({
          fk_idProgramacion: this.idProgramacion,
          idDerivacion: this.idDerivacion,
        });
        await this.fetchDerivacionesByArea(this.derivacion.fk_idEquipoApplication);
        this.loading = false;
        this.$router.push('/investigacion_socioeconomica/antecedentes');
      }
    },
  },
};
</script>
